import { useAlertContext } from "../contexts/AlertContext";

const useAlert = () => {
  return useAlertContext();
};

export default useAlert;
